<ng-container *transloco="let t">
    <ng-container *ngIf="showHeader">
        <ng-container *tuiLet="isScrollList$ | async as isScrollList">
            <h4 class="text-lg font-semibold mb-2" *ngIf="isScrollList">
                {{ t('product_categories').toUpperCase() }}
            </h4>
            <div class="food-list-header">
                <div class="flex gap-2">
                    <ng-container *tuiLet="searchInputFocused$ | async as searchInputFocused">
                        <button
                            *ngIf="!searchInputFocused && !isScrollList"
                            tuiButton
                            appearance="outline"
                            iconRight="svg::chevron-down"
                            [size]="INPUT_SIZE"
                            class="flex-auto btn-wide"
                            style="width: calc(100% - 5rem - 0.5rem)"
                            (click)="handleClickCategoryBtn()"
                        >
                            <span class="truncate">{{ (selectedCategory$ | async)?.name || t('product') }}</span>
                        </button>

                        <tui-input
                            *ngIf="!isScrollList"
                            tuiTextfieldIconLeft="tuiIconSearch"
                            [tuiTextfieldCleaner]="true"
                            [formControl]="searchCtrl"
                            [tuiTextfieldLabelOutside]="true"
                            [tuiTextfieldSize]="INPUT_SIZE"
                            class="shadow-none"
                            [ngClass]="{
                                'flex-none': !searchInputFocused && !isScrollList,
                                'w-20': !searchInputFocused && !isScrollList,
                                'flex-auto': searchInputFocused || isScrollList
                            }"
                            (focusedChange)="handleSearchInputFocus($event)"
                        >
                            {{ t('search') }}
                            <input tuiTextfield [placeholder]="'search_product' | transloco" />
                        </tui-input>

                        <tui-input
                            *ngIf="isScrollList"
                            tuiTextfieldCustomContent="tuiIconSearch"
                            [tuiTextfieldCleaner]="true"
                            [formControl]="searchCtrl"
                            [tuiTextfieldLabelOutside]="true"
                            [tuiTextfieldSize]="INPUT_SIZE"
                            class="shadow-none w-20 flex-auto"
                            (focusedChange)="handleSearchInputFocus($event)"
                        >
                            {{ t('search_v2') }}
                            <input tuiTextfield [placeholder]="'search_product' | transloco" />
                        </tui-input>

                        <button
                            *ngIf="searchInputFocused && !isScrollList"
                            tuiIconButton
                            appearance="outline"
                            icon="svg::close"
                            class="flex-none"
                            [size]="INPUT_SIZE"
                            (click)="handleCloseSearchInput()"
                        ></button>
                    </ng-container>

                    <!-- <ng-container *tuiLet='layout$ | async as layout'>
                        <button
                            tuiIconButton
                            type='button'
                            appearance='outline'
                            [icon]="layout === Layout.Grid ? 'svg::bar-3' : 'svg::squares-2x2'"
                            size='s'
                            (click)='onChangeLayout(layout === Layout.Grid ? Layout.List : Layout.Grid)'
                        ></button>
                    </ng-container> -->
                </div>
            </div>
            <ng-container *ngIf="categories$ | async as categories">
                <ng-container *ngIf="categories.length > 0 && (isScrollList$ | async) === true">
                    <ng-container *tuiLet="width_category$ | async as width_category">
                        <tui-carousel
                            [draggable]="true"
                            [itemsCount]="(index_count$ | async) || 2"
                            [(index)]="index"
                            #carousel
                            class="{{ width_category }}-height mt-2 mb-2 bg-current"
                            *tuiLet="selectedCategory$ | async as selectedCategory"
                        >
                            <ng-container *ngFor="let item of categories">
                                <div
                                    *tuiItem
                                    class="rounded-xl {{ width_category }}"
                                    [ngClass]="{
                                        'bg-category-active': selectedCategory && selectedCategory.id === item.id
                                    }"
                                    (click)="handleSelect(item)"
                                >
                                    <img
                                        class="mx-auto object-cover w-full img-category"
                                        [src]="item.category_thumbnail || DEFAULT_IMAGE"
                                        priority="true"
                                        draggable="false"
                                        [ngClass]="{
                                            'rounded-x-none': selectedCategory && selectedCategory.id === item.id
                                        }"
                                    />
                                    <p
                                        class="text-sm text-gray-700 px-3 text-center line-clamp-2"
                                        [ngClass]="{
                                            'text-white': selectedCategory && selectedCategory.id === item.id
                                        }"
                                    >
                                        {{ item.name }}
                                    </p>
                                </div>
                            </ng-container>
                        </tui-carousel>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-container *tuiLet="layout$ | async as layout">
        <ng-container *ngIf="filteredCategories$ | async as filteredCategories; else blank">
            <div class="">
                <div
                    *ngFor="let category of filteredCategories; trackBy: trackById"
                    class="mb-6"
                    style="scroll-margin-top: 110px"
                    [attr.id]="'category-' + category.id"
                >
                    <h4 class="text-lg font-semibold mb-2">
                        {{ category.name }}
                    </h4>

                    <ul
                        [ngClass]="
                            layout === Layout.List
                                ? 'flex flex-col gap-4'
                                : 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 gap-x-3 md:gap-x-4 xl:gap-x-5 gap-y-4 lg:gap-y-5 xl:lg:gap-y-6 2xl:gap-y-8'
                        "
                    >
                        <li *ngFor="let item of category.items; trackBy: trackById">
                            <us-product-item
                                [layout]="layout === Layout.List ? Layout.List : Layout.Grid"
                                [item]="item"
                            >
                            </us-product-item>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- <ng-container *ngIf="currentTotalItems + 1 < totalItems">
                <div class="flex justify-center items-center">
                    <button tuiButton type="button" appearance="outline" size="m" (click)="loadData()">
                        {{ 'load_more' | transloco }}
                    </button>
                </div>
            </ng-container> -->
        </ng-container>

        <ng-template #blank>
            {{ t('no_data_found') }}
        </ng-template>

        <!-- <ion-infinite-scroll (ionInfinite)="loadData($event)">
            <ion-infinite-scroll-content loadingSpinner="bubbles" [loadingText]="('loading' | transloco) + '...'">
            </ion-infinite-scroll-content>
        </ion-infinite-scroll> -->
    </ng-container>
</ng-container>
